import React from "react";
import { TESTIMONIALS } from "../mock";
import { Script } from "./Script";

export default function Testimonials() {
  return (
    <section id="reference" className="bg-white py-24 md:py-32" data-testid="testimonials-section">
      <div className="container-x">
        <h2 className="reveal display text-[#0e0e0d] text-4xl sm:text-5xl lg:text-6xl max-w-3xl">
          Neberte to jen od nás —{" "}
          <Script color="#0e0e0d" className="text-5xl sm:text-6xl lg:text-7xl mx-2">
            máme výsledky.
          </Script>
        </h2>

        <div className="mt-20 grid md:grid-cols-3 gap-5">
          {TESTIMONIALS.map((t) => (
            <figure
              key={t.name}
              data-testid={`testimonial-${t.name.split(" ")[0].toLowerCase()}`}
              className="reveal tile p-8 md:p-9 flex flex-col"
            >
              <blockquote className="text-[#0e0e0d] text-lg leading-relaxed flex-1">“{t.text}”</blockquote>
              <figcaption className="flex items-center gap-4 mt-8">
                <img
                  src={t.avatar}
                  alt={t.name}
                  loading="lazy"
                  className="w-12 h-12 rounded-full object-cover grayscale"
                />
                <div>
                  <p className="font-semibold text-[#0e0e0d]">{t.name}</p>
                  <p className="text-xs text-[#8b8b84]">
                    {t.role} · {t.since}
                  </p>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
